import { useEffect } from "react";

import Query from "@/models/query";

export function useQueryResetter(query: Query) {
  useEffect(() => () => query.reset(), [query]);
}
